export const API_ENDPOINTS = {
    NAMELIST_CUSTOMER: ({ customerNumber }) =>
        `/catalog/v1.1/customers/${customerNumber}/namelist-customer`,
    NAMELIST_VERIFICATION: ({ customerNumber, consumerId }) =>
        `/catalog/v1.1/customers/${customerNumber}/namelist-verification/${consumerId}`,
}
